import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './assets/iconfont/iconfont.css';
import App from './App';
import { HashRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
 
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HashRouter>
    <App />
  </HashRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// 监听beforeinstallprompt事件
const handleBeforeInstallPrompt = (e) => {
  // console.log('beforeinstallprompt e...', e);
  // 阻止浏览器默认提示
  e.preventDefault();
  // 保存事件，以便在用户点击按钮时触发
  window.deferredPrompt = e;
};

window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);